<parkour-action [link]="link">
  <div
    class="flex p-4 justify-between items-center rounded bg-n-200 hover:bg-n-300 transition-colors"
    [ngClass]="{
      'bg-n-150': teamlid.status === 'GEBLOKKEERD',
      'bg-n-200': teamlid.status !== 'GEBLOKKEERD',
    }"
  >
    <parkour-profiel-block [profielData]="teamlid" />

    <parkour-icon class="text-n-600" name="chevron-right" size="3" />
  </div>
</parkour-action>
